const mediaItems = [
  {
    title: '香蕉视频 · 热门大片推荐',
    desc: '最新上架的高分影视剧集，从动作大片到温情剧情，满足不同口味观影需求。支持高清流畅播放。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20dramatic%20lighting%20and%20warm%20color%20grading%2C%20film%20projector%20beam%20in%20dark%20theater%2C%20elegant%20golden%20and%20coral%20accents%2C%20movie%20poster%20aesthetic%2C%20professional%20cinematography%20style%2C%20soft%20lens%20flare&width=800&height=450&seq=media-card-01&orientation=landscape',
    tag: '影视剧集',
    tagClass: 'bg-primary-100 text-primary-700',
    duration: '海量资源',
  },
  {
    title: '红桃视频 · 原创综艺精选',
    desc: '独家自制综艺节目，从真人秀到访谈栏目，高品质自制内容持续输出，打造差异化观看体验。',
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20studio%20set%20with%20colorful%20stage%20lighting%20and%20warm%20atmosphere%2C%20professional%20production%20environment%2C%20modern%20entertainment%20aesthetic%2C%20bright%20vibrant%20colors%20with%20soft%20glow%2C%20dynamic%20composition&width=800&height=450&seq=media-card-02&orientation=landscape',
    tag: '自制综艺',
    tagClass: 'bg-accent-100 text-accent-800',
    duration: '持续更新',
  },
  {
    title: '樱花视频 · 日剧专区',
    desc: '字幕组精译日剧资源，涵盖悬疑推理、爱情喜剧、职场励志等多元题材，定期更新最新译制作品。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20scene%20aesthetic%20with%20cherry%20blossom%20petals%20and%20warm%20soft%20lighting%2C%20elegant%20minimalist%20composition%2C%20subtle%20pink%20and%20golden%20tones%2C%20serene%20atmospheric%20mood%2C%20cinematic%20quality&width=800&height=450&seq=media-card-03&orientation=landscape',
    tag: '日韩影视',
    tagClass: 'bg-secondary-100 text-secondary-800',
    duration: '精选译制',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门推荐</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选各大视频平台优质内容方向，发现更多精彩
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-xl md:text-2xl text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${item.tagClass}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="text-xs px-2 py-0.5 rounded bg-background-950/60 text-background-50 font-medium">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}